import { useEffect, useState } from 'react';

import { deviceIdName } from '@/constants/settings';

export interface IDevice {
  id: string;
  ip?: string;
  userAgent?: string;
  platform?: string;
  mobile?: string;
}

interface IDeviceProps {
  metadata?: boolean;
  skipFetch?: boolean;
}

export const useDevice = (props?: IDeviceProps) => {
  const [device, setDevice] = useState<IDevice | null>(null);
  const [isLoading, setIsLoading] = useState(!props?.skipFetch);

  const getDevice = async () => {
    setIsLoading(true);
    try {
      const device = await fetch('/api/device').then((res) => res.json());

      localStorage.setItem(deviceIdName, device.id);

      setIsLoading(false);
      return device;
    } catch (error) {
      setIsLoading(false);
      throw error;
    }
  };

  const getDeviceId = async () => {
    let id = localStorage.getItem(deviceIdName);

    if (!id) {
      const { id: deviceId } = await getDevice();
      id = deviceId;
    }

    return id;
  };

  const fetchData = async () => {
    let device: IDevice;

    if (props?.metadata) {
      device = await getDevice();
    } else {
      device = {
        id: await getDeviceId(),
      };
    }

    setDevice(device);

    return device;
  };

  useEffect(() => {
    if (props?.skipFetch) {
      return;
    }

    fetchData();
  }, []);

  return {
    device,
    fetchData,
    isLoading,
  };
};
